import { COMMAND_BOX_TYPE } from "@kourai/api/home-board";
import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/**
 * The command box: the composer at the top of the board. The page draws it (it's the chat's
 * composer), so this entry only reserves its type: pinned, never in the add tray, never removed.
 */
export default defineWidget({
  type: COMMAND_BOX_TYPE,
  version: 1,
  title: "Command box",
  description: "Ask, search or open a page",
  sizes: ["w"],
  surfaces: ["newtab"],
  data: "none",
  permissions: [],
  pinned: true,
  max: 1,
  config: z.object({}),
  load: async () => ({ default: () => null }),
});
